<template>
  <div class="flex flex-col justify-center w-full">
    <section
      v-for="promoItem in promoItems"
      :key="promoItem.id"
      class="sheet"
      :class="
        promoItem.appearance.position === 'left'
          ? 'flex justify-start'
          : 'flex justify-end'
      "
      :style="[
        promoItem.appearance.bgImage
          ? { 'background-image': 'url(' + promoItem.appearance.bgImage + ')' }
          : {
              'background-image': `url(${require('../../assets/promocodes_promo.png')})`,
            },
      ]"
    >
      <div class="sheet-content">
        <img
          class="sheet-logo"
          :src="
            promoItem.appearance.promoLogo
              ? promoItem.appearance.promoLogo
              : require('../../assets/SVG/logo.svg')
          "
          alt="Логотип"
        />
        <h2 class="sheet-main-text" v-html="eventPeriodText(promoItem)"></h2>
        <p
          class="sheet-main-text"
          style="color: #ffce42 !important"
          v-html="isFreeGame(promoItem)"
        ></p>
        <div class="big-promo">{{ promoItem.code }}</div>

        <h2
          class="text-brand-yellow text-xl"
          v-html="
            promoItem.appearance.howToUseText ||
            'Как воспользоваться промокодом?'
          "
        ></h2>
        <br />
        <p
          v-if="!promoItem.appearance.howToUseText"
          class="text-white font-bold text-sm"
        >
          1. Регистрируемся на портале<span class="font-bold text-brand-yellow">
            mozgo.com</span
          ><br />
          и создаем личный кабинет команды.<br /><br />2. Выбираем игру и
          регистрируемся на неё,<br />
          вписываем информацию о команде.<br /><br />3. В поле
          <span class="font-bold text-brand-yellow">«Промокод»</span> вводим
          необходимые<br />
          символы из сертификата.
        </p>
        <!-- <p class="sheet-simple-text" style="margin-bottom: 14mm;">
          <strong>Мозгобойня</strong> – игра из вопросов и ответов в барах и ресторанах твоего города.
        </p> -->
        <!-- <div
          class="step"
          style="display: flex;font-size: 3.5mm; align-items: center; margin-top: 2mm"
        >
          <img src="../../assets/SVG/fire-block-white.svg" style="width: 13mm; height: 13mm;" alt />
          <p
            style="color: #ffffff; line-height: 1.3; font-weight:normal ; padding: 0 4mm; border-right: 1.5px solid white;"
          >
            Переходи на сайт
            <br />
            <span style="font-weight: bold; color: #FFCE42;">portal.mozgo.com</span>
            <br />и выбирай игру!
          </p>

          <p style="font-weight: bold; color: #FFCE42; line-height: 1.3; padding: 0 4mm;">
            Собирай команду
            <br />и участвуй{{promoItem.value === 100 ? ' бесплатно' : ' со скидкой'}}!
          </p>
        </div> -->
        <div
          style="
            margin-top: 25mm;
            font-size: 3.5mm;
            font-weight: normal;
            color: #ffffff;
            line-height: 1.3;
          "
        >
          <p>
            {{
              promoItem.appearance.expiredAtText
                ? promoItem.appearance.expiredAtText
                : "Промокод действителен до"
            }}
            <span style="font-weight: bold; color: #ffce42">{{
              promoItem.expiredAt
            }}</span>
            включительно.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import parse from "date-fns/parse";
import format from "date-fns/format";
import ru from "date-fns/locale/ru";
import axios from "axios";
// import ApiNamespaceService from "~/services/api-namespace";

export default {
  layout: "promocodes",
  // :to="{name: 'questions', params: {type: $route.params.type, tour: 1}}"
  data() {
    return {
      promoItems: [],
      promoCodeUrl: this.$route.params.packId,
    };
  },
  methods: {
    formatExpired(exipredAt) {
      return format(parse(exipredAt), "dd.MM.yyyy", {
        locale: ru,
      });
    },
    totalClaims(total) {
      return total === 1 ? "и только один раз" : `${total} раз`;
    },
    eventPeriodText(promoItem) {
      if (promoItem.appearance.title) {
        return promoItem.appearance.title;
      }
      if (!promoItem.config.day_id && !promoItem.config.seria_id) {
        return "Твоя лучшая встреча с Мозгобойней";
      } else if (!promoItem.config.day_id && promoItem.config.seria_id) {
        return `Твоя лучшая встреча с Мозгобойней на любой игре ${promoItem.gameTypeName} ${promoItem.seriaDatesRange}`;
      } else if (promoItem.config.day_id) {
        return `Твоя лучшая встреча с Мозгобойней на игре ${promoItem.gameTypeName} - ${promoItem.dayPlace} - ${promoItem.dayDate}`;
      }
    },
    isFreeGame(item) {
      if (item.value === 100) {
        return "Играй бесплатно!";
      }
      return item.appearance.discountText || `Играй со скидкой ${item.value}%`;
    },
  },
  computed: {
    onlineEndpoint(endpoint, version = "v1") {
      return `/api/live/${version}${endpoint}`;
    },
  },
  created() {
    document.cookie = `callibri_nowidget=true; path=${document.location.pathname}; `;
    axios
      .get(`${process.env.VUE_APP_BACKEND}/promos/${this.promoCodeUrl}`)
      .then((response) => {
        if (response.data.data.length) {
          setTimeout(() => {
            window.print();
          }, 300);
          return (this.promoItems = response.data.data);
        }
        throw {
          statusCode: 404,
          message: "Promo items not found",
        };
      });
  },
  mounted() {},
};
</script>
<style>
.sheet {
  /* background: url("../../assets/promocodes_promo.png"); */
  background-size: cover;
  box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
  margin: 6.22mm auto;
  padding: 22mm 30mm 22mm 40mm;
  width: 297mm;
  height: 195mm;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}

.sheet-content {
  width: 50%;
  /* margin: 0 0 0 auto; */
  font-family: Montserrat;
  font-style: normal;
}

.sheet-logo {
  width: 100%;
  margin-bottom: 9mm;
}

.sheet-main-text {
  font-size: 5mm;
  line-height: 1.2;
  font-weight: 700;
  color: #fff;
  margin-bottom: 3mm;
}

.sheet-simple-text {
  font-size: 3.7mm;
  font-style: normal;
  font-weight: normal;
  color: #fff;
}

.big-promo {
  margin-top: 14mm;
  margin-bottom: 14mm;
  width: 97%;
  padding-left: 8mm;
  border: 3px solid #ffffff;
  height: 19mm;
  border-radius: 4.96mm;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 7.5mm;
  color: #ffce42;
  font-weight: 800;
  position: relative;
}
.big-promo:after {
  content: "промокод";
  display: block;
  position: absolute;
  background-color: #58004a;
  color: #ffffff;
  padding: 0 1mm;
  font-size: 4mm;
  letter-spacing: normal;
  top: -14%;
}
</style>
